export const tabKeys = {
  mockUser: 'mockUser',
  realUser: 'realUser',
};
